import { useEffect, useState } from "react";
import AppLayout from "@/components/AppLayout";
import { AdminSidebar } from "@/components/sidebars";
import { apiClient } from "@/lib/api";

export default function AdminMiembros() {
  const [list, setList] = useState([]);
  useEffect(() => { apiClient.get("/admin/members").then(({ data }) => setList(data)).catch(() => {}); }, []);
  return (
    <AppLayout sidebar={AdminSidebar}>
      <header className="app-header"><h1>Miembros</h1><p className="text-muted">{list.length} cliente(s) registrados</p></header>
      <div className="panel">
        <table className="data-table">
          <thead><tr><th>Nombre</th><th>Email</th><th>Plan</th><th>Status</th><th>Benef.</th><th>Tel EU</th><th>Estado EU</th><th>Creado</th></tr></thead>
          <tbody>
            {list.map((u) => (
              <tr key={u.id} data-testid={`miembro-${u.id}`}>
                <td><strong>{u.nombre}</strong></td>
                <td>{u.email}</td>
                <td>{u.plan || "—"}</td>
                <td><span className={`sol-pill sol-${u.membership_status === "active" ? "completada" : "pendiente"}`}>{u.membership_status || "—"}</span></td>
                <td>{(u.beneficiarios || []).length}</td>
                <td>{u.telefono || "—"}</td>
                <td>{u.direccion_eu_estado || "—"}</td>
                <td>{u.created_at ? new Date(u.created_at).toLocaleDateString("es-MX") : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </AppLayout>
  );
}
